export default {
  athlete: "athlete",
  commitmentList: "Commitment List",
  emptyStateMessage:
    "No commitments available at this time. Please check back at a later date.",
  position: "position",
  stars: "stars"
};
